module.exports = __webpack_public_path__ + "static/media/Masa para Tacos.514486f0.jpg";